// @ts-nocheck
/* eslint-disable */
import React, { useEffect } from 'react';

export const trackCustomEvent = (eventName: string, data: any = {}) => {
  // @ts-ignore
  if (window.fbq) {
    // @ts-ignore
    window.fbq("trackCustom", eventName, data);
  }
};

export default function MetaPixelWrapper({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    // Avoid injecting multiple times
    if (window.fbq) return;

    // Inject the pixel script
    (function (f, b, e, v, n, t, s) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = true;
      t.src = 'https://connect.facebook.net/en_US/fbevents.js';
      s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s);
    }(window, document, 'script'));

    window.fbq('init', process.env.REACT_APP_META_PIXEL_ID);
    window.fbq('track', 'PageView');
  }, []);

  return <>{children}</>;
}
